import { RelBox } from '../../../api/ai.api.types';
import { AI_FAST_DETECT_ACQUIRE_MS, AI_FAST_DETECT_TRACK_MS, AI_FAST_DETECT_READ_MS, AI_HIRES_MIN_BOX_AREA } from './liveConstants';

// Which regime the fast box-detection loop is in — this drives its poll cadence.
// 'acquire' = no local lock yet (initial search or the tracker lost the meter); poll often to
//   re-localize. 'track' = the client keypoint tracker holds the box locally, so fast only
//   re-anchors against drift. 'read' = the meter is framed close and the hi-res detect/ loop is
//   running (it re-anchors the box itself), so fast drops to a heartbeat.
export type DetectionPhase = 'acquire' | 'track' | 'read';

export const computeDetectionPhase = (trackerMode: 'tracking' | 'snap', box: RelBox | null, readingGateOpen: boolean): DetectionPhase => {
    const area = box ? box.w * box.h : 0;
    // Same gate as the hi-res detect/ loop's activation condition (AiReadingScreen.tsx): fast drops to its heartbeat exactly when the hi-res loop takes over re-anchoring. Keep these in lockstep.
    if (readingGateOpen && area >= AI_HIRES_MIN_BOX_AREA) {
        return 'read';
    }
    if (trackerMode === 'tracking') {
        return 'track';
    }
    return 'acquire';
};

export const fastDetectDelayMs = (phase: DetectionPhase): number => {
    switch (phase) {
        case 'read':
            return AI_FAST_DETECT_READ_MS;
        case 'track':
            return AI_FAST_DETECT_TRACK_MS;
        case 'acquire':
        default:
            return AI_FAST_DETECT_ACQUIRE_MS;
    }
};
